module.exports = __webpack_public_path__ + "img/dwg.9a55eb3c.svg";